import React, { useState } from 'react';
import Divider from '../Divider';
import {
  CustomInput,
  ReskinningAutocomplete,
} from '../../../../../../Components';
import { Copy01Icon } from '../../../../../../assets/icons';
import { CustomMapDialog } from '../../../../../../Components';
import { useSelectedTheme } from '../../../../../../Hooks';

import useStyles from '../styles';
function CPP_PD_BasicInformationSection({
  data,
  selected,
  setSelected,
  translate,
  getNewValue,
  handleSelectedChange,
}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const copyHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (selected.urlLocation) {
      navigator.clipboard
        .writeText(selected.urlLocation)
        .then(() => {
          setShowTooltip(true);
          setTimeout(() => setShowTooltip(false), 2000);
        })
        .catch((err) => {
          const textArea = document.createElement('textarea');
          textArea.value = selected.urlLocation;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          try {
            document.execCommand('copy');
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 2000);
          } catch (fallbackErr) {}
          document.body.removeChild(textArea);
        });
    }
  };

  return (
    <>
      <div className={styles.basicInfoWrapper}>
        <div className={styles.CPP_basicInfoHeader}>
          <span>{translate('basic-information')}</span>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('property-plan')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <ReskinningAutocomplete
              idRef={'propertyPlanRef'}
              data={data?.propertyPlans || []}
              withoutSearchButton
              isLoading={false}
              multiple={false}
              inputPlaceholder={translate('select')}
              displayLabel={(option) => option?.lookupItemName || ''}
              chipsLabel={(option) => option?.lookupItemName || ''}
              getOptionSelected={(option, value) =>
                option?.lookupItemId === value?.lookupItemId
              }
              selectedValues={selected?.propertyPlan}
              onChange={(e, value) => {
                setSelected({
                  id: 'propertyPlan',
                  value: value || null,
                });
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('property-type')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <ReskinningAutocomplete
              idRef={'propertyTypeRef'}
              inputPlaceholder={translate('select')}
              style={{ width: '100%' }}
              data={data?.propertyTypes || []}
              selectedValues={selected?.propertyType}
              withoutSearchButton
              isLoading={false}
              multiple={false}
              displayLabel={(option) => option?.lookupItemName || ''}
              chipsLabel={(option) => option?.lookupItemName || ''}
              getOptionSelected={(option, value) =>
                option?.lookupItemId === value?.lookupItemId
              }
              onChange={(e, newValue) => {
                setSelected({
                  id: 'propertyType',
                  value: newValue || null,
                });
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('property-usage')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <ReskinningAutocomplete
              idRef={'propertyUsageRef'}
              inputPlaceholder={translate('select')}
              style={{ width: '100%' }}
              data={data?.propertyUsages || []}
              selectedValues={selected?.propertyUsage}
              withoutSearchButton
              isLoading={false}
              multiple={false}
              displayLabel={(option) => option?.lookupItemName || ''}
              chipsLabel={(option) => option?.lookupItemName || ''}
              getOptionSelected={(option, value) =>
                option?.lookupItemId === value?.lookupItemId
              }
              onChange={(e, newValue) => {
                setSelected({
                  id: 'propertyUsage',
                  value: newValue || null,
                });
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('zone-type')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <ReskinningAutocomplete
              inputPlaceholder={translate('select')}
              style={{ width: '100%' }}
              data={data?.zoneTypes || []}
              selectedValues={selected?.zoneType}
              withoutSearchButton
              isLoading={false}
              multiple={false}
              displayLabel={(option) => option?.lookupItemName || ''}
              chipsLabel={(option) => option?.lookupItemName || ''}
              getOptionSelected={(option, value) =>
                option?.lookupItemId === value?.lookupItemId
              }
              onChange={(e, newValue) => {
                setSelected({
                  id: 'zoneType',
                  value: newValue || null,
                });
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('ownership')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <ReskinningAutocomplete
              idRef={'ownershipRef'}
              inputPlaceholder={translate('select')}
              style={{ width: '100%' }}
              data={data?.ownerships || []}
              selectedValues={selected?.ownership}
              withoutSearchButton
              isLoading={false}
              multiple={false}
              displayLabel={(option) => option?.lookupItemName || ''}
              chipsLabel={(option) => option?.lookupItemName || ''}
              getOptionSelected={(option, value) =>
                option?.lookupItemId === value?.lookupItemId
              }
              onChange={(e, newValue) => {
                setSelected({
                  id: 'ownership',
                  value: newValue || null,
                });
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('community')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <ReskinningAutocomplete
              idRef={'communityRef'}
              inputPlaceholder={translate('select')}
              style={{ width: '100%' }}
              data={data?.communities || []}
              selectedValues={selected?.community}
              withoutSearchButton
              isLoading={false}
              multiple={false}
              displayLabel={(option) => option?.lookupItemName || ''}
              chipsLabel={(option) => option?.lookupItemName || ''}
              getOptionSelected={(option, value) =>
                option?.lookupItemId === value?.lookupItemId
              }
              onChange={(e, newValue) => {
                setSelected({
                  id: 'community',
                  value: newValue || null,
                });
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('url_location')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <CustomInput
              placeholder={translate('enter')}
              hasSearchIcon={false}
              style={{ minWidth: '100%', cursor: 'pointer' }}
              value={selected.urlLocation}
              handleClick={() => setOpenMapDialog(true)}
              onChange={(e) => {
                handleSelectedChange('urlLocation', e.target.value);
              }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                gap: '8px',
                position: 'relative',
              }}
            >
              <Copy01Icon
                onClick={copyHandler}
                width={20}
                height={20}
                style={{
                  cursor: selected.urlLocation ? 'pointer' : 'default',
                  opacity: selected.urlLocation ? 1 : 0.5,
                }}
              />

              <div
                style={{
                  position: 'absolute',
                  top: '-38px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: palette.background.primary_solid || '#333',
                  color: palette.text.white || '#fff',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  fontSize: '12px',
                  fontWeight: 500,
                  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
                  zIndex: 1000,
                  opacity: showTooltip ? 1 : 0,
                  visibility: showTooltip ? 'visible' : 'hidden',
                  transition: 'opacity 0.3s ease, visibility 0.3s ease',
                  whiteSpace: 'nowrap',
                  pointerEvents: 'none',
                }}
              >
                {translate('copied')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {openMapDialog && (
        <CustomMapDialog
          open={openMapDialog}
          onChange={(mapData) => {
            if (mapData && mapData.latitude && mapData.longitude) {
              const locationString = `${mapData.latitude}, ${mapData.longitude}`;
              handleSelectedChange('urlLocation', locationString);
            }
          }}
          initialState={
            selected.urlLocation && selected.urlLocation.includes(',')
              ? {
                  latitude: parseFloat(
                    selected.urlLocation.split(',')[0]?.trim()
                  ),
                  longitude: parseFloat(
                    selected.urlLocation.split(',')[1]?.trim()
                  ),
                }
              : null
          }
          closeDialog={() => {
            setOpenMapDialog(false);
          }}
        />
      )}
    </>
  );
}

export default CPP_PD_BasicInformationSection;
